export default __webpack_public_path__ + "static/media/21-Carnival.b6db4c6c.jpg";